import { FunctionComponent, PropsWithChildren, ReactNode } from 'react'
import { ProviderDrawerTitle } from '@/modules/accredited-establishments/components'
import { ProviderDrawerSkeleton, ProviderKind } from './ProviderDrawerSkeleton'
import { ProviderDrawerError } from './ProviderDrawerError'
import { SlidePanel } from '@/global/components/SlidePanel'
import { zIndex } from '@/global/constants/z-index'
import { useSurvey } from '@/modules/accredited-establishments/hooks'

interface ProviderDetails {
  title: string
  image: string
  /** Tags sob o titulo: modalidade, conselho, CNPJ. */
  tags?: string[]
}

interface ProviderDrawerProps extends PropsWithChildren {
  id: string
  loading?: boolean
  error?: boolean
  data?: ProviderDetails
  /** Botoes extras no cabecalho, ao lado do fechar. */
  actions?: ReactNode
  /** Define o desenho do skeleton, que difere entre os dois detalhes. */
  kind?: ProviderKind
}

const ProviderDrawer: FunctionComponent<ProviderDrawerProps> = ({
  id,
  loading,
  error,
  data,
  actions,
  kind,
  children
}) => {
  const { openSurvey } = useSurvey('treatment')

  return (
    <SlidePanel
      id={id}
      /* Mesma folga e mesmo raio do painel do menu (`.navbar-drawer-panel`). */
      floating
      /* No mobile o painel sobe da base, como uma bandeja. */
      mobilePosition='bottom'
      className={`w-full rounded-t-gl-border-radius-xg lg:w-[556px] lg:rounded-gl-border-radius-xg ${zIndex.accreditedEstablishments.providerDrawer}`}
      actions={actions}
      onClose={() => openSurvey()}
    >
      {loading ? <ProviderDrawerSkeleton kind={kind} /> : null}

      {error ? <ProviderDrawerError /> : null}

      {data ? (
        /*
         * Os 96px repetem o offset do handoff: os botoes do topo ocupam de 32px
         * a 72px, e o conteudo comeca abaixo deles.
         */
        <div className='flex flex-col lg:px-gl-spacing-10 pt-[96px]'>
          <ProviderDrawerTitle
            title={data.title}
            image={data.image}
            tags={data.tags}
          />

          {children}
        </div>
      ) : null}
    </SlidePanel>
  )
}

export type { ProviderDrawerProps, ProviderDetails }

export { ProviderDrawer }
